import React from 'react';
import { Placeholder } from '@sitecore-jss/sitecore-jss-react';

const Section = ({ rendering, fields, params }) => {
  return (
    <div
      className={`vds-page-container__section${
        params?.variant ? ` vds-page-container__section--${params?.variant} ` : ''
      }`}
      data-testid={`${fields?.testid?.value}-section`}
    >
      <div className="vds-page-container__inner">
        <Placeholder name="section-content" rendering={rendering} />
      </div>
    </div>
  );
};

export default Section;
